import { cloneElement, FC } from 'react';
import { Theme, lighten } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Typography, Toolbar } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'mir-utils/i18n';
import { SelectButtonRender } from '../../../SelectButton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    highlight: {
      color: theme.palette.secondary.main,
      backgroundColor: lighten(theme.palette.secondary.light, 0.85),
    },
  })
);

type Props = {
  selectButton: SelectButtonRender<any> | null;
  selectedElements: any[];
};

/**
 * @summary Toolbar для групповых операций над элементами.
 *
 * @param selectButton - Компонент с кнопками для групповой активности.
 * @param selectedElements - Список выбранных элементов.
 */
export const TableToolbarSelectRow: FC<Props> = ({ selectButton, selectedElements }) => {
  const classes = useStyles();

  const { t } = useTranslation();

  return (
    <Toolbar
      className={clsx(classes.root, {
        [classes.highlight]: selectedElements.length > 0,
      })}
    >
      <Typography>{t('{{number}} selected', { number: selectedElements.length })}</Typography>
      {selectButton && cloneElement(selectButton, { selected: selectedElements })}
    </Toolbar>
  );
};
